import { render, staticRenderFns } from "./FooterSklad.vue?vue&type=template&id=725515d7&scoped=true"
import script from "./FooterSklad.vue?vue&type=script&lang=js"
export * from "./FooterSklad.vue?vue&type=script&lang=js"
import style0 from "./FooterSklad.vue?vue&type=style&index=0&id=725515d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725515d7",
  null
  
)

export default component.exports